import DoublePopoverConfirm from "@/components/DoublePopoverConfirm/DoublePopoverConfirm";
import useTranslation from "@/hooks/useTranslation";
import { message } from "antd";
import { ReactNode } from "react";
import { useDeleteCommute, useDeleteCommuteAll } from "@/pages/employee/commute/useCommute";
import { ExclamationCircleFilled } from "@ant-design/icons";

export default function DeleteCommuteAction({
  year,
  disabled = false,
  children,
  onSuccess,
}: {
  year?: number;
  disabled?: boolean;
  children: ReactNode;
  onSuccess?: () => void;
}) {
  const translation = useTranslation();

  const deleteCommute = useDeleteCommute();
  const deleteCommuteAll = useDeleteCommuteAll();

  const deleteAll = async () => {
    await deleteCommuteAll.mutateAsync();
  };

  const deleteYear = async () => {
    await deleteCommute.mutateAsync({ year });
  };

  return (
    <DoublePopoverConfirm
      trigger={["click"]}
      title={"Delete commute"}
      description={
        <>
          <p>Are you sure you want to delete commute data?</p>
          <p style={{ color: "#F5222D" }}>This action can not be undone.</p>
        </>
      }
      icon={<ExclamationCircleFilled style={{ color: "#F5222D" }} />}
      onConfirm1={() =>
        deleteAll()
          .then(() => {
            onSuccess && onSuccess();
          })
          .catch(() => message.error(translation.errors.general))
      }
      onConfirm2={
        year
          ? () =>
              deleteYear()
                .then(() => {
                  onSuccess && onSuccess();
                })
                .catch(() => message.error(translation.errors.general))
          : undefined
      }
      placement="bottom"
      button1Props={{
        children: "Delete all commute",
        danger: true,
      }}
      button2Props={{
        children: `Delete ${year} commute`,
        danger: true,
      }}
      cancelButtonProps={{ children: "Cancel" }}
      disabled={disabled}
    >
      {children}
    </DoublePopoverConfirm>
  );
}
